<template>
  <div>
    <swiper :options="swiperOption" ref="mySwiper">
      <!-- slides -->
      <swiper-slide style="overflow: hidden;" v-for="(item, i) in mediaItems" v-bind:data="item" v-bind:key="i">
        <div class="swiper-slide-header">
          <div class="swiper-slide-title">{{item.title}}</div>
          <div class="swiper-slide-description">{{item.description}}</div>
          <div v-on:click="closeModal()" class="swiper-slide-close"></div>
        </div>
        <div v-if="item.type == 'video'" class="video-block">
          <div class="swiper-lazy-preloader"></div>
          <youtube :resize="true" :player-vars="playerVars" @ready="ready" :video-id="getVideoIdByUrl(item.url)" class="swiper-lazy youtube-media"></youtube>
        </div>
        <div v-if="item.type == 'image'">
          <div class="swiper-lazy-preloader"></div>
          <img v-bind:data-src="item.url" class="swiper-lazy">
        </div>
      </swiper-slide>

      <!-- Optional controls -->
      <div class="swiper-pagination"  slot="pagination"></div>
      <div class="swiper-button-prev" slot="button-prev"></div>
      <div class="swiper-button-next" slot="button-next"></div>
      <div class="swiper-scrollbar"   slot="scrollbar"></div>
    </swiper>
  </div>
</template>

<script>
  import { loadImage } from "@src/helpers/image-helper";

  export default {
    name: "media-slide",
    props: {
      mediaItems: Array,
      index: null
    },
    components: {
    },
    data() {
      return {
        player: null,
        playerVars: {
          autoplay: false
        },
        swiperOption: {
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          }
        }
      }
    },
    watch: {
      mediaItems: function(to) {
        this.mediaItems = to;
        this.adjustMediaItems();
      },
      index: function(to) {
        this.index = to;
        if (this.index) this.swiper.slideTo(this.index, 1000, false);
      }
    },
    computed: {
      swiper: function(){
        return this.$refs.mySwiper.swiper;
      }
    },
    mounted() {
      this.adjustMediaItems();
      setTimeout(() => {
        if(!this.index) this.swiper.virtual.update();
      }, 500);
      this.swiper.on('slideChange', () => {
        this.player.pauseVideo();
      });
    },
    methods: {
      ready(player) {
        this.player = player;
      },
      adjustMediaItems() {
        this.mediaItems.map((item, i) => {
          if(item.type == 'image') {
            loadImage(
              item.url,
              'https://ukuyadev.s3.amazonaws.com/system/blog_default.jpg',
              null,
              src => item.url = src
            );
          }          
          if(this.mediaItems.length - 1 == i){
            this.swiper.slideTo(this.index, 0, false);
          }
        });
      },
      getVideoIdByUrl(url) {
        return url.split('/')[3].substr(8, 20);
      },
      closeModal() {
        this.$emit('close');
      }
    }
  }
</script>

<style lang="scss" scoped>
  .swiper-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 999999;
    background: #222!important;
  }
  .swiper-slide {
    text-align: center;
    font-size: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    background: #222!important;
  }
  .swiper-slide img {
    width: auto;
    height: auto;
    max-width: 100%;
    max-height: 100%;
    -ms-transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    position: absolute;
    left: 50%;
    top: 50%;
  }
  .swiper-slide-close {
    position: absolute;
    top: 0;
    right: 0;
    color: #fff;
    display: inline-block;
    width: 60px;
    height: 60px;
    background-image: url("/vue-app/assets/img/close.svg");
    background-position: center center;
    background-repeat: no-repeat;
    background-size: 60%;
    cursor: pointer;
  }
  .swiper-slide-header {
    position: absolute;
    top: 0;
    color: #fff;
    background-color: rgba(0, 0, 0, 0.36);
    display: block;
    width: 100%;
    z-index: 99;
  }
  .swiper-button-prev, .swiper-button-next {
    z-index: 99999999;
    cursor: pointer;
  }
  @media only screen and (max-width: 767px) {
    .swiper-button-prev, .swiper-button-next {
      display: none;
    }
    .video-block {
      max-width: 100%;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  @media only screen and (min-width: 768px) {
    .video-block {
      display: block;
    }
  }
  .swiper-slide-title {
    line-height: 34px;
  }
  .swiper-slide-description {
    font-size: 14px;
    line-height: 22px;
  }
  .video-block {
    max-width: 640px;
    width: 640px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>
